// src/components/texting/TextsAwaitingWidget.jsx
// Dashboard counter: how many suggested texts are due for approval right now.
// Renders nothing for roles without texting or when the queue is empty.
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare, ChevronRight } from "lucide-react";
import { useStateValue } from "../../context/StateProvider";
import { canUseTexting } from "../../utils/texting";
import { useSuggestedTextJobs } from "../../utils/textJobs";

export default function TextsAwaitingWidget() {
  const [{ user }] = useStateValue();
  const navigate = useNavigate();
  const allowed = canUseTexting(user);
  const jobs = useSuggestedTextJobs(allowed);
  const due = useMemo(() => {
    const now = Date.now();
    return jobs.filter((j) => (j.dueAt || 0) <= now).length;
  }, [jobs]);

  if (!allowed || due === 0) return null;

  return (
    <button
      onClick={() => navigate("/dashboard/texting")}
      className="w-full text-left bg-white border border-slate-200 border-l-4 border-l-blue-500 rounded-xl px-4 py-3 flex items-center gap-3 hover:bg-slate-50"
    >
      <MessageSquare size={18} className="text-linkColor flex-shrink-0" />
      <span className="text-sm text-slate-700">
        <b className="text-linkColor">
          {due} text{due === 1 ? "" : "s"}
        </b>{" "}
        waiting for your approval
      </span>
      <span className="ml-auto inline-flex items-center gap-0.5 text-xs font-semibold text-linkColor">
        Review <ChevronRight size={14} />
      </span>
    </button>
  );
}
